module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"You have no active jobs","publishedTill":"Published till: {date}"}}')
  delete Component.options._Ctor
}
